import { c as create_ssr_component, v as validate_component } from "../../../../chunks/ssr.js";
import { B as BookOpenPageVariant, S as ServicePageTemplate } from "../../../../chunks/ServicePageTemplate.js";
import { A as AccountCowboyHatOutline } from "../../../../chunks/AccountCowboyHatOutline.js";
import { A as AirplaneTakeoff } from "../../../../chunks/AirplaneTakeoff.js";
import { C as CheckDecagram } from "../../../../chunks/CheckDecagram.js";
import { C as CopyCard } from "../../../../chunks/CopyCard.js";
let programs = true;
let pricingPackage = false;
let professionalProgram = false;
let financing = false;
let background_center = true;
let hero_image = "/eaglet_roll.webp";
let h1 = "Sport Pilot Program";
let hero_paragraph_content = "The Sport Pilot certificate represents a new way to fly that is safe, fun, and more affordable. It allows those interested in flight to obtain their rating in half the time and for half the cost of the traditional Private Pilot certificate. So climb aboard, take the controls, and launch into new adventures in aviation today.";
let center_img_seperating_section = false;
let second_center_img_seperating_section = false;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let roadmap_stages = [
    [
      {
        text: "Orientation / Discover flight",
        icon: AccountCowboyHatOutline
      },
      {
        text: "Sport Pilot Training",
        icon: BookOpenPageVariant
      },
      {
        text: "Sport Pilot Checkride",
        icon: AirplaneTakeoff
      },
      {
        text: "Sport Pilot Acheived",
        icon: CheckDecagram
      }
    ]
  ];
  let prerequisites = {
    eligibility: [
      "Be at least 17 years old",
      "Be able to read, speak, write, and understand the English language proficiently",
      "Hold a U.S. student pilot pilot certificate",
      "Receive ground training or home study the required aeronautical knowledge",
      "Have an instructor certifying that you are prepared for the required knowledge test",
      "Have an instructor certify that you are prepared for the practical test",
      "Pass the knowledge test on aeronautical knowledge",
      "Have received flight training from a certified flight instructor in areas of operation (listed below)",
      "Pass the practical test"
    ],
    proficiency: [
      "Preflight preparation",
      "Preflight procedures",
      "Airport operations",
      "Takeoffs, landings, and go-arounds",
      "Performance maneuvers",
      "Ground reference maneuvers",
      "Navigation",
      "Slow flight and stalls",
      "Emergency operations",
      "Post-flight procedures"
    ],
    experience: [
      "20 hours of flight time",
      "15 hours of flight training",
      "5 hours of solo flight training",
      "2 hours of cross-country flight training",
      "10 takeoffs and landings to a full stop",
      "One solo cross-country flight of at least 75 nautical miles total distance, with a full-stop landing at a minimum of two points and one segment of the flight consisting of a straight-line distance of at least 25 nautical miles between the takeoff and landing locations",
      "2 hours of flight training with an authorized instructor on those areas of operation within the preceding 2 calendar months from the month of the test"
    ]
  };
  let faqs = [
    {
      question: "What is a sport pilot license?",
      answer: "A sport pilot license is a type of pilot certificate issued by aviation authorities, such as the FAA in the United States. It is a more accessible and affordable option for those who want to fly for recreational purposes. Sport pilots are limited in the size and speed of the aircraft they can operate, typically flying light sport aircraft (LSA). The training requirements for a sport pilot license are less stringent than those for a private pilot license.",
      opened: false
    },
    {
      question: "Can I work while taking the course?",
      answer: "Many students work part-time while pursuing their PPL. However, it's essential to balance your time effectively to ensure successful completion of the course.",
      opened: false
    },
    {
      question: "Can I choose when to schedule my flight lessons?",
      answer: "Yes, flight lessons are often flexible and can be scheduled to fit your availability, as long as your flight instructor is available.",
      opened: false
    }
  ];
  return `${$$result.head += `<!-- HEAD_svelte-tdffl4_START -->${$$result.title = `<title>Sports Pilot | First Landings Aviation</title>`, ""}<meta name="description" content="First Landings Aviation sport pilot training"><!-- HEAD_svelte-tdffl4_END -->`, ""} ${validate_component(ServicePageTemplate, "ServicePageTemplate").$$render(
    $$result,
    {
      faqs,
      programs,
      pricingPackage,
      professionalProgram,
      hero_image,
      background_center,
      financing,
      h1,
      hero_paragraph_content,
      roadmap_stages,
      center_img_seperating_section,
      second_center_img_seperating_section,
      prerequisites
    },
    {},
    {
      three: () => {
        return `<div slot="three">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/eaglet_runway.webp",
            alt: "eaglet P92 entering runway"
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-1nlm994">A check-ride is an essential part of the pilot certification process
        that includes both a flight test and an oral exam. During a check-ride,
        a designated pilot examiner (DPE) assesses the pilot&#39;s ability to
        operate an aircraft safely and proficiently. The examination covers
        various aspects, including flight maneuvers, navigation, emergency
        procedures, communication skills, and a thorough understanding of
        aviation regulations.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-5aur3t">Checkride Information</div>`;
            }
          }
        )}</div>`;
      },
      two: () => {
        return `<div slot="two">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1agjs9o">In order to begin your training you must be able to read, write, speak
        and understand English proficiently. Either a FAA issued medical
        certificate or a US drivers license is needed. You will also need to
        show proof of U.S. Citizenship or TSA approval as well as your student
        pilot certificate.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-gjaehl">What Do You Need to Start?</div>`;
          }
        })}</div>`;
      },
      one: () => {
        return `<div slot="one">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/eaglet_holdshort.webp",
            alt: "eaglet P92 holding short"
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-18pomia">First Landings Aviation became Central Florida’s first sport pilot
        training center in May of 2009. Since then, we have taught more sport
        pilots to fly than any other flight schools in the country. Our alumni
        come from nearly all 50 states, and several countries around the world.
        This course will give you the knowledge and experience to earn your
        certificate and become a safe operating pilot in the aviation world. You
        can schedule your flights as you have availability, and make flying your
        new leisure activity - It’s completely up to you how long your program
        takes! All your efforts will concentrate on training you to be a safe,
        responsible, and experienced Sport Pilot ready to pass the FAA practical
        test. Our facilities also include a luxurious pilot’s lounge and area
        for students to study and work with each other while here.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1kkxrt0">Course Description</div>`;
            }
          }
        )}</div>`;
      }
    }
  )}`;
});
export {
  Page as default
};
